import React, { FC, useState } from 'react';
import {
  ShareFullScreenButtonWrapper, SocialListAction, SocialListContent,
  SocialListHeaderWrapper,
  SocialListWrapper
} from './ShareFullScreenButton.styled';
import { Button, Dialog, DialogActions } from "@mui/material";
import SocialShareDialog from "components/SocialShareDialog/SocialShareDialog";
import ShareSocialList from "components/ShareSocialList/ShareSocialList";
import I18n from "i18n/I18n";
import { FormattedMessage as Translate } from "react-intl";


function ShareFullScreenButton({shareId}) {

  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = () => {
    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <ShareFullScreenButtonWrapper data-testid="ShareFullScreenButton" id="share-fullscreen-btn">
        <Button size={'small'} onClick={handleOpen}>
          <img src="/share-arrow.svg" alt={'icon-share-button'}/>
        </Button>
      </ShareFullScreenButtonWrapper>

      {open &&

        <I18n>
          <SocialListWrapper>
            <SocialListContent>
              <SocialListHeaderWrapper>
                <Translate id={'Partager'}/>
              </SocialListHeaderWrapper>
              <ShareSocialList shareId={shareId}></ShareSocialList>

              <SocialListAction>
                <Button onClick={handleClose}>
                  <Translate id="Fermer" defaultMessage={'Fermer'}/>
                </Button>
              </SocialListAction>
            </SocialListContent>

          </SocialListWrapper>

        </I18n>

      }

    </>

  )
}


export default ShareFullScreenButton;
